
export const urlBase1 = "https://bac.varascundo.com";
export const urlBase = `${urlBase1}/api`;

export const UrlPeintureDigital = `${urlBase}/oeuvres`;
export const UrlCategorie = `${urlBase}/categories`;

export const UrlTheme = `${urlBase}/themes`;
export const URLimage = `${urlBase1}/images/oeuvre`;
export const URLOeuvreId = `${urlBase}/oeuvres`;
export const URLPageAccueil = `${urlBase}/page_accueils`;

export const URLImageAccueil = `${urlBase1}/images/Accueil/`;
